// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets//Career/Flag.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets//Career//Recognition.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/Career/Mashal.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/Career/Thinking.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Career-container {
    margin-bottom: 1rem;
}

.Career-containerOne {
    margin: 0% 10%;
    display: flex;
    justify-content: space-around;
    margin-top: 250px;
    margin-bottom: var(--margin-bottom-web);
}

.Career-container-oneTitle {
    margin-top: 0px;
    font-size: 22px;
    font-weight: 900;
    margin-bottom: 12px;
}

.Career-container-oneTitle2 {
    font-size: 82px;
    line-height: 83px;
    font-weight: lighter;
    margin-top: 0px;
    margin-bottom: 26px;
}

.Career-container-oneSubTitle {
    font-weight: bolder;
    line-height: 83px;
}

.Career-container-oneInfo {
    margin-top: 0px;
    font-size: 28px;
    line-height: 42px;
    margin-bottom: 40px;
    font-weight: 500;
    padding-right: 20px;
}

.career-container-subOne {
    display: flex;
    gap: 13px;
}

.career-container-btnone,
.career-container-btntwo {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    border-radius: 50px;
    font-size: 18px;
}

.career-container-btnone {
    width: 204px;
    height: 60px;
    color: white;
    background-color: #20303F;
    border: none;
    padding: 27px 52px;
}

.career-container-btntwo {
    width: 200px;
    color: black;
    background-color: white;
}

.career-container-two {
    width: 50%;
}

.career-container-two img {
    padding-top: 40px;
    margin-bottom: 0px;
    width: 100;
}

/* mediaOne */
@media (max-width: 1280px) {
    .Career-containerOne {
        margin: 0% 10%;
        display: flex;
        flex-direction: column;
    }

    .career-container-two {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .career-container-two img {
        width: 60%;
    }
}

@media (max-width: 500px) {
    .Career-containerOne {
        margin: 0% 5%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .Career-container-oneTitle {
        margin-top: 0px;
        font-size: 20px;
    }

    .Career-container-oneTitle2 {
        width: 100vw;
        margin-top: 6px;
        margin-bottom: 0px;
        line-height: 1;
        font-size: 35px;
        font-weight: lighter;
    }

    .Career-container-oneInfo {
        width: 80vw;
        margin-top: 13px;
        margin-bottom: 23px;
        font-size: 16px;
        font-weight: normal;
        line-height: 20px;
    }

    .career-container-btnone,
    .career-container-btntwo {
        height: 40px;
        font-size: 10px;
        padding: 0%;
    }

    .career-container-btnone {
        width: 120px;
        color: white;

    }

    .career-container-btntwo {
        width: 130px;
        color: black;
    }

    .career-container-two {
        width: 75%;
        display: flex;
        justify-content: left;
        margin-bottom: 50px;
    }

    .career-container-two img {
        width: 80vw;
    }
}

/* 2 */

.Career-containerTwo {
    width: 100%;
    margin-bottom: var(--margin-bottom-web);
    position: relative;
}

.HadnShakeimg {
    width: 100%;
}

.Career-containerTwo-one {
    position: absolute;
    bottom: -50px;
    left: 28%;
    transform: translateX(-50%);
    background: #0B63E5;
    color: white;
    border-top-right-radius: 50px;
    padding: 2% 2% 1% 2%;
    width: 35%;
}

.logoT {
    width: 180px;
    height: auto;
}

.Career-containerTwo-line2 {
    margin-top: 25px;
    font-size: 48px;
    font-weight: 200;
    margin-bottom: 20px;
    line-height: 50px;
    /* border: 1px solid ; */
}

.homepage-content-one-line3 {
    font-size: 48px;
    font-weight: 800;
    line-height: 56px;
}

.Career-containerTwo-line4 {
    font-size: 18.51px;
    font-weight: 400;
    line-height: 27.85px;
}

.Career-containerTwo-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.getConnected-button {
    font-size: 15px;
    font-weight: bold;
    color: white;
    background-color: #20303F;
    padding: 20px 40px 20px 40px;
    border: none;
    border-radius: 50px;
}

.Career-containerTwo-bottom>img {
    width: 72.19px;
    height: 109px;
    top: 1477px;
    left: 811.82px;
    gap: 0px;
    border-radius: 3.79px 0px 0px 0px;
}

/* Media for 2nd */
@media (max-width: 1280px) {

    .Career-containerTwo {
        height: 500px;
        overflow: hidden;
    }

    .HadnShakeimg {
        clip-path: polygon(5% 0%, 100% 0%, 100% 0%, 100% 100%, 0% 100%, 0% 20%);
        overflow: hidden;
    }

    .Career-containerTwo-one {
        top: 70px;
        left: 50%;
        border-radius: 0%;
        padding: 1% 1% 4% 2%;
        width: 75vw;
        height: 60%;
    }

    .logoT {
        width: 70px;
        height: 15px;
    }

    .Career-containerTwo-line1 {
        margin-top: 12px;
        margin-bottom: 0px;
        font-size: 12px;
        font-weight: 700;
    }

    .Career-containerTwo-line2 {
        font-size: 25px;
        line-height: 30px;
        font-weight: 200;
    }

    .Career-containerTwo-line2 span {
        font-size: 25px;
        line-height: 30px;
        font-weight: 800;
    }

    .getConnected-button {
        padding: 10.42px 21.67px 10.83px 21.67px;
        font-size: 14px;
        font-weight: 800;
        line-height: 20.37px;
    }

    .Career-containerTwo-bottom>img {
        width: 10%;
        margin-top: 4%;
        height: 70px;
    }
}

@media (max-width: 500px) {
    .Career-containerTwo {
        margin-top: 50px;
        margin-bottom: 10px;
    }


    .HadnShakeimg {
        width: 100vh;
        height: 150vw;
    }

    .Career-containerTwo-one {
        top: 70px;
        left: 50%;
        height: 70%;
        width: 280px;
        padding: 5% 5% 5% 2%;
    }

    .Career-containerTwo-bottom>img {
        width: 10%;
        height: auto;
        margin-top: 5%;
    }

    .getConnected-button {
        margin-top: 20px;
        padding: 10.42px 21.67px 10.83px 21.67px;
        font-size: 14px;
        font-weight: 500;
    }

    .Career-containerTwo-line2 {
        font-size: 25px;
    }

    .Career-containerTwo-line4 {
        font-size: 15px;
    }
}

/* 3 */
.Career-containerThree {
    margin: 0% 9.5% 5rem 18%;
    display: flex;
    justify-content: space-between;
}

.Career-container-Three {
    margin: 70px 0px;
    width: 45%;
}

.Career-container-Three-Line1 {
    font-weight: lighter;
    font-size: 40px;
    line-height: 110%;
    margin: 0px;
}

.Career-container-Three-Line2 {
    font-size: 40px;
    line-height: 110%;
    margin: 0px;
}

.Career-container-Three-subLine2 {
    color: rgb(11, 12, 229);
}

.Career-container-Three-Line3 {
    font-size: 25px;
    font-weight: normal;
    margin-top: 30px;
}

.Career-container-Three-two {
    width: 60%;
    overflow: hidden;
}

.Career-container-Three-two img {
    width: 100%;
    height: 100%;
}

/* media 3 */
@media (max-width: 1280px) {
    .Career-containerThree {
        margin: 0% 5%;
        display: flex;
        flex-direction: column;
        margin-top: -100px
    }

    .Career-container-Three {
        width: 100%;
    }

    .Career-container-Three-two {
        width: 100%;
        margin-left: -10%;
        margin-top: -20%
    }

    .Career-container-Three-two img {
        width: 120%;
    }

}

@media (max-width: 500px) {
    .Career-containerThree {
        margin: 0% 5%;
        margin-top: 0px;
        display: flex;
        flex-direction: column;
        margin-bottom: 50px;
    }

    .Career-container-Three {
        margin: 70px 0px;
        width: 100%;
    }

    .Career-container-Three-Line1 {
        font-weight: lighter;
        font-size: 25px;
        line-height: 100%;
    }

    .Career-container-Three-Line2 {
        font-size: 25px;
    }

    .Career-container-Three-Line3 {
        font-size: 20px;
    }

    .Career-container-Three-two {
        width: 100%;
        margin-left: -10%;
        margin-top: -20%
    }

    .Career-container-Three-two img {
        width: 120%;
    }
}

/* 4 */
.Career-containerFour {
    margin-bottom: var(--margin-bottom-web);
}

.Career-containerFourOne {
    margin: 0px 17% 0% 18%;
}

.Career-containerFourOne hr {
    border: 1px solid;
}

.Career-container-Four {
    display: flex;
    margin: 40px 17% 0% 18%;
    column-gap: 500px;
    justify-content: space-between;
}

.Career-container-Four p {
    margin: 0px;
}

.Career-container-Four>:nth-child(1) {
    width: 100%;
}

.Career-container-FourLine1 {
    font-size: 36px;
}

.Career-container-FourLine1 span {
    font-size: 36px;
    font-weight: 800;
    line-height: 39.6px;
}

.Career-container-FourLine2 {
    font-size: 14px;
    line-height: 24.5px;
}

/* media4.1 */
@media (max-width: 1280px) {
    .Career-containerFourOne {
        margin: 0px 5%;
    }

    .Career-container-Four {
        flex-direction: column;
        margin: 0% 5%;
    }

    .Career-container-FourLine1 p {
        margin-bottom: 5px;
    }

    .Career-container-FourLine1 span {
        font-size: 25px;
        font-weight: 800;
        line-height: 39.6px;
    }
}

@media (max-width: 500px) {
    .Career-containerFourOne {
        margin: 0px 5%;
    }

    .Career-container-Four {
        flex-direction: column;
        margin: 0% 5%;
        column-gap: 0px;
    }

    .Career-container-FourLine1 p {
        margin-bottom: 5px;
        font-size: 25px;
    }
}

/* 4.2 */
.Career-containerFourTwo {
    margin: 40px 17% 0% 18%;
}

.Career-containerFourTwo-One {
    display: flex;
    justify-content: space-between;
    column-gap: 30px;
}

.Career-containerFourTwo-1 {
    border-radius: 40px;
    width: 50%;
    height: 450px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-repeat: no-repeat;
}

.Career-containerFourTwo-content {
    padding: 10% 30% 0% 5%;
}

.Career-containerFourTwo-1-Line1 {
    font-size: 15px;
    font-weight: 600;
    line-height: 23px;
    color: rgba(255, 255, 255, 1);
    width: 54px;
    height: 23px;
}

.Career-containerFourTwo-1-Line2 {
    margin-top: 8px;
    font-size: 28px;
    font-weight: 700;
    line-height: 28px;
    color: rgba(255, 255, 255, 1);
    margin-bottom: 0px;
}

.Career-containerFourTwo-1-Line3 {
    margin-top: 8px;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    padding-right: 5%;
    letter-spacing: -0.3700000047683716px;
    color: rgba(255, 255, 255, 1);
}

/* 4.2 media */
@media (max-width: 1280px) {
    .Career-containerFourTwo {
        margin: 2% 5%;
    }

    .Career-containerFourTwo-1 {
        width: 100%;
        height: 35vw;
        background-size: cover;
        background-size: contain;
    }

    .Career-containerFourTwo-content {
        padding: 2% 20% 0% 5%;
    }

    .Career-containerFourTwo-2-Line2 {
        font-size: 25px;
    }

    .Career-containerFourTwo-2-Line3 {
        font-size: 15px;
    }

    .Career-containerFourTwo-1-Line2 {
        font-size: 20px;
    }

    .Career-containerFourTwo-1-Line3 {
        font-size: 15px;
    }
}

@media (max-width: 500px) {
    .Career-containerFourTwo {
        margin: 0% 5%;
    }

    .Career-containerFourTwo-1 {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
    }

    .Career-containerFourTwo-One {
        margin-top: 20px;
        flex-direction: column;
        row-gap: 30px;
    }

    .Career-containerFourTwo-1 {
        width: auto;
        height: auto;
    }

    .Career-containerFourTwo-content {
        padding: 0% 25% 5% 5%;
    }

    .Career-containerFourTwo-1-Line2 {
        margin-top: -5px;
        font-size: 20px;
        font-weight: 800;
        color: rgba(255, 255, 255, 1);
    }

    .Career-containerFourTwo-1-Line3 {
        font-size: 15px;
        font-weight: 400;
        line-height: 20px;
        padding-right: 5%;
        color: rgba(255, 255, 255, 1);
    }
}

/* 2nd div */

.Career-containerFourTwo-2 {
    width: 70%;
    height: 450px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 40px;

}

.Career-containerFourTwo-2-content {
    padding: 10% 50% 0% 5%;
}

.Career-containerFourTwo-2-Line1 {
    font-size: 15px;
    font-weight: 600;
    line-height: 23px;
    color: rgba(255, 255, 255, 1);
    width: 54px;
    height: 23px;
}

.Career-containerFourTwo-2-Line2 {
    margin-top: 8px;
    font-size: 28px;
    font-weight: 700;
    line-height: 28px;
    color: rgba(255, 255, 255, 1);
    margin-bottom: 0px;
}

.Career-containerFourTwo-2-Line3 {
    margin-top: 8px;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    color: rgba(255, 255, 255, 1);
}

/* media 2nd div */
@media (max-width: 1280px) {
    .Career-containerFourTwo-2 {
        width: 100%;
        height: 35vw;
        background-size: 145%;
        background-repeat: no-repeat;
        border-radius: 10%;
    }

    .Career-containerFourTwo-2-content {
        padding: 2% 20% 0% 5%;
        border-radius: 5%;
    }

    .Career-containerFourTwo-2-Line2 {
        font-size: 20px;
    }

    .Career-containerFourTwo-2-Line3 {
        font-size: 15px;
    }
}

@media (max-width: 500px) {

    .Career-containerFourTwo-2 {
        background-size: cover;
        width: 100%;
        height: 100%;
    }

    .Career-containerFourTwo-2-content {
        padding: 0% 20% 5% 2%;
    }

    .Career-containerFourTwo-2-Line1 {
        font-size: 15px;
    }

    .Career-containerFourTwo-2-Line2 {
        margin-top: 8px;
        font-size: 20px;
        font-weight: 800;
        line-height: 1;
    }

    .Career-containerFourTwo-2-Line3 {
        margin-top: 8px;
        font-size: 15px;
        font-weight: 400;
        line-height: 1.5;
    }
}


/* 3rd div */
.Career-containerFourTwo-Two {
    display: flex;
    justify-content: space-between;
    column-gap: 30px;
    margin-top: 25px;
}

.Career-containerFourTwo-Two-1 {
    border-radius: 40px;
    width: 70%;
    height: 350px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.Career-containerFourTwo-Two-1 div {
    background-size: cover;
}

.Career-containerFourTwo-Two-1+div {
    background-size: cover;
}

.Career-containerFourTwo-Two-content {
    padding: 15% 30% 0% 5%;
}

.Career-containerFourTwo-Two-1-Line1 {
    font-size: 15px;
    font-weight: 600;
    line-height: 23px;
    color: rgba(255, 255, 255, 1);
    width: 54px;
    height: 23px;
}

.Career-containerFourTwo-Two-1-Line2 {
    margin-top: 8px;
    font-size: 28px;
    font-weight: 700;
    line-height: 28px;
    color: rgba(255, 255, 255, 1);
    margin-bottom: 0px;
}

.Career-containerFourTwo-Two-1-Line3 {
    margin-top: 8px;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    padding-right: 5%;
    letter-spacing: -0.3700000047683716px;
    color: rgba(255, 255, 255, 1);
}

/* media 3rd div */
@media (max-width: 1280px) {


    .Career-containerFourTwo-Two-1 {
        width: 100%;
        height: 35vw;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
        background-size: cover;
        background-repeat: no-repeat;
    }

    .Career-containerFourTwo-Two-1 div {
        padding: 2% 25% 0% 5%;
        border-radius: 5%;
    }

    .Career-containerFourTwo-Two-1-Line2 {
        font-size: 25px;
    }

    .Career-containerFourTwo-Two-1-Line3 {
        font-size: 15px;

    }
}

@media (max-width: 500px) {
    .Career-containerFourTwo-Two {
        flex-direction: column;
        row-gap: 30px;
    }

    .Career-containerFourTwo-Two-1 {
        width: 100%;
        height: 10%;
        margin-bottom: -85px;
    }

    .Career-containerFourTwo-Two-1 div {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
        background-size: cover;
        border-radius: 50px;
    }

    .Career-containerFourTwo-Two-content {
        padding: 5% 20% 2% 2%;
    }

    .Career-containerFourTwo-Two-1-Line2 {
        margin-top: 8px;
        font-size: 20px;
        font-weight: 800;
        line-height: 1;
    }

    .Career-containerFourTwo-Two-1-Line3 {
        margin-top: 8px;
        font-size: 15px;
        font-weight: 400;
        line-height: 1.5;
    }
}


/* 4th div */
.Career-containerFourTwo-Two-2 {
    width: 70%;
    height: 350px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: contain;
    background-repeat: no-repeat;
    border-radius: 40px;
}

.Career-containerFourTwo-Two-2-content {
    padding: 15% 40% 0% 5%;
}

.Career-containerFourTwo-Two-2-Line1 {
    font-size: 15px;
    font-weight: 600;
    line-height: 23px;
    color: rgba(255, 255, 255, 1);
    width: 54px;
    height: 23px;
}

.Career-containerFourTwo-Two-2-Line2 {
    margin-top: 8px;
    font-size: 28px;
    font-weight: 700;
    line-height: 28px;
    color: rgba(255, 255, 255, 1);
    margin-bottom: 0px;
}

.Career-containerFourTwo-Two-2-Line3 {
    margin-top: 8px;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    color: rgba(255, 255, 255, 1);
}

/*media 4th div */
@media (max-width: 1280px) {

    .Career-containerFourTwo-Two-2 {
        width: 100%;
        height: 35vw;
        background-size: cover;
        background-repeat: no-repeat;
    }

    .Career-containerFourTwo-Two-2 div {
        padding: 10%15% 0% 5%;
        border-radius: 5%;
    }

    .Career-containerFourTwo-Two-2-Line2 {
        font-size: 25px;
        font-weight: 800;
        line-height: 1;
    }

    .Career-containerFourTwo-Two-2-Line3 {
        margin-top: 5px;
        font-size: 17px;
        font-weight: 400;
        line-height: 1.5;
    }
}

@media (max-width: 500px) {
    .Career-containerFourTwo-Two-2 {
        margin-top: 80px;
        width: 100vp;
        height: 60vw;
    }

    .Career-containerFourTwo-Two-2 div {
        padding: 2% 15% 0% 5%;
        border-radius: 5%;
    }

    .Career-containerFourTwo-Two-2-content {
        padding: 10% 22% 2% 2%;
    }

    .Career-containerFourTwo-Two-2-Line2 {
        margin-top: -5px;
        font-size: 20px;
        font-weight: 800;
        line-height: 1;
    }

    .Career-containerFourTwo-Two-2-Line3 {
        margin-top: 5px;
        font-size: 15px;
        font-weight: 400;
        line-height: 1.5;
    }
}


/* 5 */
.Career-containerFive {
    margin-bottom: var(--margin-bottom-web);
    font-size: 36px;
    font-weight: lighter;
    line-height: 60px;
    text-align: center;
}

.Career-containerFive-Line1 {
    margin: 0px;
}

.Career-containerFive-Line2 {
    font-weight: 900;
    margin: 0px;
}

.Career-containerFive-Line2 span {
    display: inline-block;
    vertical-align: top;

}

.Career-containerFive-Line2 span img {
    width: 100%;
    height: auto;
    vertical-align: middle;
}

/* media5 */
@media (max-width: 1280px) {
    .Career-containerFive {
        margin: 10% 5%;
    }
}

@media (max-width: 500px) {

    .Career-containerFive {
        margin-top: -80px;
        font-size: 25px;
        line-height: 1.5;
        margin-bottom: 80px;
    }

    .Career-containerFive-Line1 {
        margin: 10px;
    }


    .Career-containerFive-Line2 span img {
        width: 90%;
        height: auto;
        vertical-align: top;
    }

    #Job-Opening {
        display: none;
    }
}

/* 6 */

.Career-containerSix {
    margin: 0% 10% 5rem 10%;
    /* margin-bottom: var(--margin-bottom-web); */
}

.Career-containerSix-one p {
    margin-top: 50px;
    font-size: 28px;
    margin: 0px;
    text-align: center;
}

.Career-containerSix-one>:nth-child(1) {
    font-weight: lighter;
}

.Career-containerSix-one>:nth-child(2) {
    font-weight: bolder;
}

.Career-containerSix-Two {
    margin-top: 30px;
}`, "",{"version":3,"sources":["webpack://./src/styles/Career/Career.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,6BAA6B;IAC7B,iBAAiB;IACjB,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA,aAAa;AACb;IACI;QACI,cAAc;QACd,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,aAAa;QACb,uBAAuB;IAC3B;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,aAAa;QACb,aAAa;QACb,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,cAAc;QACd,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,mBAAmB;QACnB,eAAe;QACf,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;;QAEI,YAAY;QACZ,eAAe;QACf,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,YAAY;;IAEhB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,aAAa;QACb,qBAAqB;QACrB,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA,MAAM;;AAEN;IACI,WAAW;IACX,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;IACZ,6BAA6B;IAC7B,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,4BAA4B;IAC5B,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,WAAW;IACX,cAAc;IACd,QAAQ;IACR,iCAAiC;AACrC;;AAEA,kBAAkB;AAClB;;IAEI;QACI,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,uEAAuE;QACvE,gBAAgB;IACpB;;IAEA;QACI,SAAS;QACT,SAAS;QACT,iBAAiB;QACjB,oBAAoB;QACpB,WAAW;QACX,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,wCAAwC;QACxC,eAAe;QACf,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,UAAU;QACV,cAAc;QACd,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;;IAGA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,SAAS;QACT,SAAS;QACT,WAAW;QACX,YAAY;QACZ,oBAAoB;IACxB;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,wCAAwC;QACxC,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,MAAM;AACN;IACI,wBAAwB;IACxB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,YAAY;AACZ;IACI;QACI,aAAa;QACb,aAAa;QACb,sBAAsB;QACtB;IACJ;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB;IACJ;;IAEA;QACI,WAAW;IACf;;AAEJ;;AAEA;IACI;QACI,aAAa;QACb,eAAe;QACf,aAAa;QACb,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,oBAAoB;QACpB,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB;IACJ;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA,MAAM;AACN;IACI,uCAAuC;AAC3C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA,aAAa;AACb;IACI;QACI,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;AACJ;;AAEA,QAAQ;AACR;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,yDAAsD;IACtD,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,qCAAqC;IACrC,6BAA6B;AACjC;;AAEA,cAAc;AACd;IACI;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,sBAAsB;QACtB,wBAAwB;IAC5B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,sBAAsB;QACtB,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;QAChB,sBAAsB;QACtB,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,gBAAgB;QAChB,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,iBAAiB;QACjB,6BAA6B;IACjC;AACJ;;AAEA,YAAY;;AAEZ;IACI,UAAU;IACV,aAAa;IACb,yDAA8D;IAC9D,sBAAsB;IACtB,4BAA4B;IAC5B,mBAAmB;;AAEvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA,kBAAkB;AAClB;IACI;QACI,WAAW;QACX,YAAY;QACZ,qBAAqB;QACrB,4BAA4B;QAC5B,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;QACrB,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;;IAEI;QACI,sBAAsB;QACtB,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;;;AAGA,YAAY;AACZ;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,yDAAuD;IACvD,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,qCAAqC;IACrC,6BAA6B;AACjC;;AAEA,kBAAkB;AAClB;;;IAGI;QACI,WAAW;QACX,YAAY;QACZ,yDAAuD;QACvD,sBAAsB;QACtB,4BAA4B;IAChC;;IAEA;QACI,qBAAqB;QACrB,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;;IAEnB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,WAAW;QACX,oBAAoB;IACxB;;IAEA;QACI,yDAAuD;QACvD,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;;;AAGA,YAAY;AACZ;IACI,UAAU;IACV,aAAa;IACb,yDAAyD;IACzD,wBAAwB;IACxB,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA,iBAAiB;AACjB;;IAEI;QACI,WAAW;QACX,YAAY;QACZ,sBAAsB;QACtB,4BAA4B;IAChC;;IAEA;QACI,qBAAqB;QACrB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,qBAAqB;QACrB,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;;;AAGA,MAAM;AACN;IACI,uCAAuC;IACvC,eAAe;IACf,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;;AAEvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;;AAEA,WAAW;AACX;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;;IAEI;QACI,iBAAiB;QACjB,eAAe;QACf,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;;;IAGA;QACI,UAAU;QACV,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA,MAAM;;AAEN;IACI,uBAAuB;IACvB,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".Career-container {\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.Career-containerOne {\r\n    margin: 0% 10%;\r\n    display: flex;\r\n    justify-content: space-around;\r\n    margin-top: 250px;\r\n    margin-bottom: var(--margin-bottom-web);\r\n}\r\n\r\n.Career-container-oneTitle {\r\n    margin-top: 0px;\r\n    font-size: 22px;\r\n    font-weight: 900;\r\n    margin-bottom: 12px;\r\n}\r\n\r\n.Career-container-oneTitle2 {\r\n    font-size: 82px;\r\n    line-height: 83px;\r\n    font-weight: lighter;\r\n    margin-top: 0px;\r\n    margin-bottom: 26px;\r\n}\r\n\r\n.Career-container-oneSubTitle {\r\n    font-weight: bolder;\r\n    line-height: 83px;\r\n}\r\n\r\n.Career-container-oneInfo {\r\n    margin-top: 0px;\r\n    font-size: 28px;\r\n    line-height: 42px;\r\n    margin-bottom: 40px;\r\n    font-weight: 500;\r\n    padding-right: 20px;\r\n}\r\n\r\n.career-container-subOne {\r\n    display: flex;\r\n    gap: 13px;\r\n}\r\n\r\n.career-container-btnone,\r\n.career-container-btntwo {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 60px;\r\n    border-radius: 50px;\r\n    font-size: 18px;\r\n}\r\n\r\n.career-container-btnone {\r\n    width: 204px;\r\n    height: 60px;\r\n    color: white;\r\n    background-color: #20303F;\r\n    border: none;\r\n    padding: 27px 52px;\r\n}\r\n\r\n.career-container-btntwo {\r\n    width: 200px;\r\n    color: black;\r\n    background-color: white;\r\n}\r\n\r\n.career-container-two {\r\n    width: 50%;\r\n}\r\n\r\n.career-container-two img {\r\n    padding-top: 40px;\r\n    margin-bottom: 0px;\r\n    width: 100;\r\n}\r\n\r\n/* mediaOne */\r\n@media (max-width: 1280px) {\r\n    .Career-containerOne {\r\n        margin: 0% 10%;\r\n        display: flex;\r\n        flex-direction: column;\r\n    }\r\n\r\n    .career-container-two {\r\n        width: 100%;\r\n        display: flex;\r\n        justify-content: center;\r\n    }\r\n\r\n    .career-container-two img {\r\n        width: 60%;\r\n    }\r\n}\r\n\r\n@media (max-width: 500px) {\r\n    .Career-containerOne {\r\n        margin: 0% 5%;\r\n        display: flex;\r\n        flex-direction: column;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .Career-container-oneTitle {\r\n        margin-top: 0px;\r\n        font-size: 20px;\r\n    }\r\n\r\n    .Career-container-oneTitle2 {\r\n        width: 100vw;\r\n        margin-top: 6px;\r\n        margin-bottom: 0px;\r\n        line-height: 1;\r\n        font-size: 35px;\r\n        font-weight: lighter;\r\n    }\r\n\r\n    .Career-container-oneInfo {\r\n        width: 80vw;\r\n        margin-top: 13px;\r\n        margin-bottom: 23px;\r\n        font-size: 16px;\r\n        font-weight: normal;\r\n        line-height: 20px;\r\n    }\r\n\r\n    .career-container-btnone,\r\n    .career-container-btntwo {\r\n        height: 40px;\r\n        font-size: 10px;\r\n        padding: 0%;\r\n    }\r\n\r\n    .career-container-btnone {\r\n        width: 120px;\r\n        color: white;\r\n\r\n    }\r\n\r\n    .career-container-btntwo {\r\n        width: 130px;\r\n        color: black;\r\n    }\r\n\r\n    .career-container-two {\r\n        width: 75%;\r\n        display: flex;\r\n        justify-content: left;\r\n        margin-bottom: 50px;\r\n    }\r\n\r\n    .career-container-two img {\r\n        width: 80vw;\r\n    }\r\n}\r\n\r\n/* 2 */\r\n\r\n.Career-containerTwo {\r\n    width: 100%;\r\n    margin-bottom: var(--margin-bottom-web);\r\n    position: relative;\r\n}\r\n\r\n.HadnShakeimg {\r\n    width: 100%;\r\n}\r\n\r\n.Career-containerTwo-one {\r\n    position: absolute;\r\n    bottom: -50px;\r\n    left: 28%;\r\n    transform: translateX(-50%);\r\n    background: #0B63E5;\r\n    color: white;\r\n    border-top-right-radius: 50px;\r\n    padding: 2% 2% 1% 2%;\r\n    width: 35%;\r\n}\r\n\r\n.logoT {\r\n    width: 180px;\r\n    height: auto;\r\n}\r\n\r\n.Career-containerTwo-line2 {\r\n    margin-top: 25px;\r\n    font-size: 48px;\r\n    font-weight: 200;\r\n    margin-bottom: 20px;\r\n    line-height: 50px;\r\n    /* border: 1px solid ; */\r\n}\r\n\r\n.homepage-content-one-line3 {\r\n    font-size: 48px;\r\n    font-weight: 800;\r\n    line-height: 56px;\r\n}\r\n\r\n.Career-containerTwo-line4 {\r\n    font-size: 18.51px;\r\n    font-weight: 400;\r\n    line-height: 27.85px;\r\n}\r\n\r\n.Career-containerTwo-bottom {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.getConnected-button {\r\n    font-size: 15px;\r\n    font-weight: bold;\r\n    color: white;\r\n    background-color: #20303F;\r\n    padding: 20px 40px 20px 40px;\r\n    border: none;\r\n    border-radius: 50px;\r\n}\r\n\r\n.Career-containerTwo-bottom>img {\r\n    width: 72.19px;\r\n    height: 109px;\r\n    top: 1477px;\r\n    left: 811.82px;\r\n    gap: 0px;\r\n    border-radius: 3.79px 0px 0px 0px;\r\n}\r\n\r\n/* Media for 2nd */\r\n@media (max-width: 1280px) {\r\n\r\n    .Career-containerTwo {\r\n        height: 500px;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .HadnShakeimg {\r\n        clip-path: polygon(5% 0%, 100% 0%, 100% 0%, 100% 100%, 0% 100%, 0% 20%);\r\n        overflow: hidden;\r\n    }\r\n\r\n    .Career-containerTwo-one {\r\n        top: 70px;\r\n        left: 50%;\r\n        border-radius: 0%;\r\n        padding: 1% 1% 4% 2%;\r\n        width: 75vw;\r\n        height: 60%;\r\n    }\r\n\r\n    .logoT {\r\n        width: 70px;\r\n        height: 15px;\r\n    }\r\n\r\n    .Career-containerTwo-line1 {\r\n        margin-top: 12px;\r\n        margin-bottom: 0px;\r\n        font-size: 12px;\r\n        font-weight: 700;\r\n    }\r\n\r\n    .Career-containerTwo-line2 {\r\n        font-size: 25px;\r\n        line-height: 30px;\r\n        font-weight: 200;\r\n    }\r\n\r\n    .Career-containerTwo-line2 span {\r\n        font-size: 25px;\r\n        line-height: 30px;\r\n        font-weight: 800;\r\n    }\r\n\r\n    .getConnected-button {\r\n        padding: 10.42px 21.67px 10.83px 21.67px;\r\n        font-size: 14px;\r\n        font-weight: 800;\r\n        line-height: 20.37px;\r\n    }\r\n\r\n    .Career-containerTwo-bottom>img {\r\n        width: 10%;\r\n        margin-top: 4%;\r\n        height: 70px;\r\n    }\r\n}\r\n\r\n@media (max-width: 500px) {\r\n    .Career-containerTwo {\r\n        margin-top: 50px;\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n\r\n    .HadnShakeimg {\r\n        width: 100vh;\r\n        height: 150vw;\r\n    }\r\n\r\n    .Career-containerTwo-one {\r\n        top: 70px;\r\n        left: 50%;\r\n        height: 70%;\r\n        width: 280px;\r\n        padding: 5% 5% 5% 2%;\r\n    }\r\n\r\n    .Career-containerTwo-bottom>img {\r\n        width: 10%;\r\n        height: auto;\r\n        margin-top: 5%;\r\n    }\r\n\r\n    .getConnected-button {\r\n        margin-top: 20px;\r\n        padding: 10.42px 21.67px 10.83px 21.67px;\r\n        font-size: 14px;\r\n        font-weight: 500;\r\n    }\r\n\r\n    .Career-containerTwo-line2 {\r\n        font-size: 25px;\r\n    }\r\n\r\n    .Career-containerTwo-line4 {\r\n        font-size: 15px;\r\n    }\r\n}\r\n\r\n/* 3 */\r\n.Career-containerThree {\r\n    margin: 0% 9.5% 5rem 18%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.Career-container-Three {\r\n    margin: 70px 0px;\r\n    width: 45%;\r\n}\r\n\r\n.Career-container-Three-Line1 {\r\n    font-weight: lighter;\r\n    font-size: 40px;\r\n    line-height: 110%;\r\n    margin: 0px;\r\n}\r\n\r\n.Career-container-Three-Line2 {\r\n    font-size: 40px;\r\n    line-height: 110%;\r\n    margin: 0px;\r\n}\r\n\r\n.Career-container-Three-subLine2 {\r\n    color: rgb(11, 12, 229);\r\n}\r\n\r\n.Career-container-Three-Line3 {\r\n    font-size: 25px;\r\n    font-weight: normal;\r\n    margin-top: 30px;\r\n}\r\n\r\n.Career-container-Three-two {\r\n    width: 60%;\r\n    overflow: hidden;\r\n}\r\n\r\n.Career-container-Three-two img {\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n/* media 3 */\r\n@media (max-width: 1280px) {\r\n    .Career-containerThree {\r\n        margin: 0% 5%;\r\n        display: flex;\r\n        flex-direction: column;\r\n        margin-top: -100px\r\n    }\r\n\r\n    .Career-container-Three {\r\n        width: 100%;\r\n    }\r\n\r\n    .Career-container-Three-two {\r\n        width: 100%;\r\n        margin-left: -10%;\r\n        margin-top: -20%\r\n    }\r\n\r\n    .Career-container-Three-two img {\r\n        width: 120%;\r\n    }\r\n\r\n}\r\n\r\n@media (max-width: 500px) {\r\n    .Career-containerThree {\r\n        margin: 0% 5%;\r\n        margin-top: 0px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        margin-bottom: 50px;\r\n    }\r\n\r\n    .Career-container-Three {\r\n        margin: 70px 0px;\r\n        width: 100%;\r\n    }\r\n\r\n    .Career-container-Three-Line1 {\r\n        font-weight: lighter;\r\n        font-size: 25px;\r\n        line-height: 100%;\r\n    }\r\n\r\n    .Career-container-Three-Line2 {\r\n        font-size: 25px;\r\n    }\r\n\r\n    .Career-container-Three-Line3 {\r\n        font-size: 20px;\r\n    }\r\n\r\n    .Career-container-Three-two {\r\n        width: 100%;\r\n        margin-left: -10%;\r\n        margin-top: -20%\r\n    }\r\n\r\n    .Career-container-Three-two img {\r\n        width: 120%;\r\n    }\r\n}\r\n\r\n/* 4 */\r\n.Career-containerFour {\r\n    margin-bottom: var(--margin-bottom-web);\r\n}\r\n\r\n.Career-containerFourOne {\r\n    margin: 0px 17% 0% 18%;\r\n}\r\n\r\n.Career-containerFourOne hr {\r\n    border: 1px solid;\r\n}\r\n\r\n.Career-container-Four {\r\n    display: flex;\r\n    margin: 40px 17% 0% 18%;\r\n    column-gap: 500px;\r\n    justify-content: space-between;\r\n}\r\n\r\n.Career-container-Four p {\r\n    margin: 0px;\r\n}\r\n\r\n.Career-container-Four>:nth-child(1) {\r\n    width: 100%;\r\n}\r\n\r\n.Career-container-FourLine1 {\r\n    font-size: 36px;\r\n}\r\n\r\n.Career-container-FourLine1 span {\r\n    font-size: 36px;\r\n    font-weight: 800;\r\n    line-height: 39.6px;\r\n}\r\n\r\n.Career-container-FourLine2 {\r\n    font-size: 14px;\r\n    line-height: 24.5px;\r\n}\r\n\r\n/* media4.1 */\r\n@media (max-width: 1280px) {\r\n    .Career-containerFourOne {\r\n        margin: 0px 5%;\r\n    }\r\n\r\n    .Career-container-Four {\r\n        flex-direction: column;\r\n        margin: 0% 5%;\r\n    }\r\n\r\n    .Career-container-FourLine1 p {\r\n        margin-bottom: 5px;\r\n    }\r\n\r\n    .Career-container-FourLine1 span {\r\n        font-size: 25px;\r\n        font-weight: 800;\r\n        line-height: 39.6px;\r\n    }\r\n}\r\n\r\n@media (max-width: 500px) {\r\n    .Career-containerFourOne {\r\n        margin: 0px 5%;\r\n    }\r\n\r\n    .Career-container-Four {\r\n        flex-direction: column;\r\n        margin: 0% 5%;\r\n        column-gap: 0px;\r\n    }\r\n\r\n    .Career-container-FourLine1 p {\r\n        margin-bottom: 5px;\r\n        font-size: 25px;\r\n    }\r\n}\r\n\r\n/* 4.2 */\r\n.Career-containerFourTwo {\r\n    margin: 40px 17% 0% 18%;\r\n}\r\n\r\n.Career-containerFourTwo-One {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    column-gap: 30px;\r\n}\r\n\r\n.Career-containerFourTwo-1 {\r\n    border-radius: 40px;\r\n    width: 50%;\r\n    height: 450px;\r\n    background-image: url('../../assets//Career/Flag.png');\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n}\r\n\r\n.Career-containerFourTwo-content {\r\n    padding: 10% 30% 0% 5%;\r\n}\r\n\r\n.Career-containerFourTwo-1-Line1 {\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n    line-height: 23px;\r\n    color: rgba(255, 255, 255, 1);\r\n    width: 54px;\r\n    height: 23px;\r\n}\r\n\r\n.Career-containerFourTwo-1-Line2 {\r\n    margin-top: 8px;\r\n    font-size: 28px;\r\n    font-weight: 700;\r\n    line-height: 28px;\r\n    color: rgba(255, 255, 255, 1);\r\n    margin-bottom: 0px;\r\n}\r\n\r\n.Career-containerFourTwo-1-Line3 {\r\n    margin-top: 8px;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    line-height: 24px;\r\n    padding-right: 5%;\r\n    letter-spacing: -0.3700000047683716px;\r\n    color: rgba(255, 255, 255, 1);\r\n}\r\n\r\n/* 4.2 media */\r\n@media (max-width: 1280px) {\r\n    .Career-containerFourTwo {\r\n        margin: 2% 5%;\r\n    }\r\n\r\n    .Career-containerFourTwo-1 {\r\n        width: 100%;\r\n        height: 35vw;\r\n        background-size: cover;\r\n        background-size: contain;\r\n    }\r\n\r\n    .Career-containerFourTwo-content {\r\n        padding: 2% 20% 0% 5%;\r\n    }\r\n\r\n    .Career-containerFourTwo-2-Line2 {\r\n        font-size: 25px;\r\n    }\r\n\r\n    .Career-containerFourTwo-2-Line3 {\r\n        font-size: 15px;\r\n    }\r\n\r\n    .Career-containerFourTwo-1-Line2 {\r\n        font-size: 20px;\r\n    }\r\n\r\n    .Career-containerFourTwo-1-Line3 {\r\n        font-size: 15px;\r\n    }\r\n}\r\n\r\n@media (max-width: 500px) {\r\n    .Career-containerFourTwo {\r\n        margin: 0% 5%;\r\n    }\r\n\r\n    .Career-containerFourTwo-1 {\r\n        width: 100%;\r\n        height: 100%;\r\n        background-size: cover;\r\n        background-position: center;\r\n    }\r\n\r\n    .Career-containerFourTwo-One {\r\n        margin-top: 20px;\r\n        flex-direction: column;\r\n        row-gap: 30px;\r\n    }\r\n\r\n    .Career-containerFourTwo-1 {\r\n        width: auto;\r\n        height: auto;\r\n    }\r\n\r\n    .Career-containerFourTwo-content {\r\n        padding: 0% 25% 5% 5%;\r\n    }\r\n\r\n    .Career-containerFourTwo-1-Line2 {\r\n        margin-top: -5px;\r\n        font-size: 20px;\r\n        font-weight: 800;\r\n        color: rgba(255, 255, 255, 1);\r\n    }\r\n\r\n    .Career-containerFourTwo-1-Line3 {\r\n        font-size: 15px;\r\n        font-weight: 400;\r\n        line-height: 20px;\r\n        padding-right: 5%;\r\n        color: rgba(255, 255, 255, 1);\r\n    }\r\n}\r\n\r\n/* 2nd div */\r\n\r\n.Career-containerFourTwo-2 {\r\n    width: 70%;\r\n    height: 450px;\r\n    background-image: url('../../assets//Career//Recognition.png');\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n    border-radius: 40px;\r\n\r\n}\r\n\r\n.Career-containerFourTwo-2-content {\r\n    padding: 10% 50% 0% 5%;\r\n}\r\n\r\n.Career-containerFourTwo-2-Line1 {\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n    line-height: 23px;\r\n    color: rgba(255, 255, 255, 1);\r\n    width: 54px;\r\n    height: 23px;\r\n}\r\n\r\n.Career-containerFourTwo-2-Line2 {\r\n    margin-top: 8px;\r\n    font-size: 28px;\r\n    font-weight: 700;\r\n    line-height: 28px;\r\n    color: rgba(255, 255, 255, 1);\r\n    margin-bottom: 0px;\r\n}\r\n\r\n.Career-containerFourTwo-2-Line3 {\r\n    margin-top: 8px;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    line-height: 24px;\r\n    color: rgba(255, 255, 255, 1);\r\n}\r\n\r\n/* media 2nd div */\r\n@media (max-width: 1280px) {\r\n    .Career-containerFourTwo-2 {\r\n        width: 100%;\r\n        height: 35vw;\r\n        background-size: 145%;\r\n        background-repeat: no-repeat;\r\n        border-radius: 10%;\r\n    }\r\n\r\n    .Career-containerFourTwo-2-content {\r\n        padding: 2% 20% 0% 5%;\r\n        border-radius: 5%;\r\n    }\r\n\r\n    .Career-containerFourTwo-2-Line2 {\r\n        font-size: 20px;\r\n    }\r\n\r\n    .Career-containerFourTwo-2-Line3 {\r\n        font-size: 15px;\r\n    }\r\n}\r\n\r\n@media (max-width: 500px) {\r\n\r\n    .Career-containerFourTwo-2 {\r\n        background-size: cover;\r\n        width: 100%;\r\n        height: 100%;\r\n    }\r\n\r\n    .Career-containerFourTwo-2-content {\r\n        padding: 0% 20% 5% 2%;\r\n    }\r\n\r\n    .Career-containerFourTwo-2-Line1 {\r\n        font-size: 15px;\r\n    }\r\n\r\n    .Career-containerFourTwo-2-Line2 {\r\n        margin-top: 8px;\r\n        font-size: 20px;\r\n        font-weight: 800;\r\n        line-height: 1;\r\n    }\r\n\r\n    .Career-containerFourTwo-2-Line3 {\r\n        margin-top: 8px;\r\n        font-size: 15px;\r\n        font-weight: 400;\r\n        line-height: 1.5;\r\n    }\r\n}\r\n\r\n\r\n/* 3rd div */\r\n.Career-containerFourTwo-Two {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    column-gap: 30px;\r\n    margin-top: 25px;\r\n}\r\n\r\n.Career-containerFourTwo-Two-1 {\r\n    border-radius: 40px;\r\n    width: 70%;\r\n    height: 350px;\r\n    background-image: url('../../assets/Career/Mashal.png');\r\n    background-size: cover;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n}\r\n\r\n.Career-containerFourTwo-Two-1 div {\r\n    background-size: cover;\r\n}\r\n\r\n.Career-containerFourTwo-Two-1+div {\r\n    background-size: cover;\r\n}\r\n\r\n.Career-containerFourTwo-Two-content {\r\n    padding: 15% 30% 0% 5%;\r\n}\r\n\r\n.Career-containerFourTwo-Two-1-Line1 {\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n    line-height: 23px;\r\n    color: rgba(255, 255, 255, 1);\r\n    width: 54px;\r\n    height: 23px;\r\n}\r\n\r\n.Career-containerFourTwo-Two-1-Line2 {\r\n    margin-top: 8px;\r\n    font-size: 28px;\r\n    font-weight: 700;\r\n    line-height: 28px;\r\n    color: rgba(255, 255, 255, 1);\r\n    margin-bottom: 0px;\r\n}\r\n\r\n.Career-containerFourTwo-Two-1-Line3 {\r\n    margin-top: 8px;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    line-height: 24px;\r\n    padding-right: 5%;\r\n    letter-spacing: -0.3700000047683716px;\r\n    color: rgba(255, 255, 255, 1);\r\n}\r\n\r\n/* media 3rd div */\r\n@media (max-width: 1280px) {\r\n\r\n\r\n    .Career-containerFourTwo-Two-1 {\r\n        width: 100%;\r\n        height: 35vw;\r\n        background-image: url('../../assets/Career/Mashal.png');\r\n        background-size: cover;\r\n        background-repeat: no-repeat;\r\n    }\r\n\r\n    .Career-containerFourTwo-Two-1 div {\r\n        padding: 2% 25% 0% 5%;\r\n        border-radius: 5%;\r\n    }\r\n\r\n    .Career-containerFourTwo-Two-1-Line2 {\r\n        font-size: 25px;\r\n    }\r\n\r\n    .Career-containerFourTwo-Two-1-Line3 {\r\n        font-size: 15px;\r\n\r\n    }\r\n}\r\n\r\n@media (max-width: 500px) {\r\n    .Career-containerFourTwo-Two {\r\n        flex-direction: column;\r\n        row-gap: 30px;\r\n    }\r\n\r\n    .Career-containerFourTwo-Two-1 {\r\n        width: 100%;\r\n        height: 10%;\r\n        margin-bottom: -85px;\r\n    }\r\n\r\n    .Career-containerFourTwo-Two-1 div {\r\n        background-image: url('../../assets/Career/Mashal.png');\r\n        background-size: cover;\r\n        border-radius: 50px;\r\n    }\r\n\r\n    .Career-containerFourTwo-Two-content {\r\n        padding: 5% 20% 2% 2%;\r\n    }\r\n\r\n    .Career-containerFourTwo-Two-1-Line2 {\r\n        margin-top: 8px;\r\n        font-size: 20px;\r\n        font-weight: 800;\r\n        line-height: 1;\r\n    }\r\n\r\n    .Career-containerFourTwo-Two-1-Line3 {\r\n        margin-top: 8px;\r\n        font-size: 15px;\r\n        font-weight: 400;\r\n        line-height: 1.5;\r\n    }\r\n}\r\n\r\n\r\n/* 4th div */\r\n.Career-containerFourTwo-Two-2 {\r\n    width: 70%;\r\n    height: 350px;\r\n    background-image: url('../../assets/Career/Thinking.png');\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n    border-radius: 40px;\r\n}\r\n\r\n.Career-containerFourTwo-Two-2-content {\r\n    padding: 15% 40% 0% 5%;\r\n}\r\n\r\n.Career-containerFourTwo-Two-2-Line1 {\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n    line-height: 23px;\r\n    color: rgba(255, 255, 255, 1);\r\n    width: 54px;\r\n    height: 23px;\r\n}\r\n\r\n.Career-containerFourTwo-Two-2-Line2 {\r\n    margin-top: 8px;\r\n    font-size: 28px;\r\n    font-weight: 700;\r\n    line-height: 28px;\r\n    color: rgba(255, 255, 255, 1);\r\n    margin-bottom: 0px;\r\n}\r\n\r\n.Career-containerFourTwo-Two-2-Line3 {\r\n    margin-top: 8px;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    line-height: 24px;\r\n    color: rgba(255, 255, 255, 1);\r\n}\r\n\r\n/*media 4th div */\r\n@media (max-width: 1280px) {\r\n\r\n    .Career-containerFourTwo-Two-2 {\r\n        width: 100%;\r\n        height: 35vw;\r\n        background-size: cover;\r\n        background-repeat: no-repeat;\r\n    }\r\n\r\n    .Career-containerFourTwo-Two-2 div {\r\n        padding: 10%15% 0% 5%;\r\n        border-radius: 5%;\r\n    }\r\n\r\n    .Career-containerFourTwo-Two-2-Line2 {\r\n        font-size: 25px;\r\n        font-weight: 800;\r\n        line-height: 1;\r\n    }\r\n\r\n    .Career-containerFourTwo-Two-2-Line3 {\r\n        margin-top: 5px;\r\n        font-size: 17px;\r\n        font-weight: 400;\r\n        line-height: 1.5;\r\n    }\r\n}\r\n\r\n@media (max-width: 500px) {\r\n    .Career-containerFourTwo-Two-2 {\r\n        margin-top: 80px;\r\n        width: 100vp;\r\n        height: 60vw;\r\n    }\r\n\r\n    .Career-containerFourTwo-Two-2 div {\r\n        padding: 2% 15% 0% 5%;\r\n        border-radius: 5%;\r\n    }\r\n\r\n    .Career-containerFourTwo-Two-2-content {\r\n        padding: 10% 22% 2% 2%;\r\n    }\r\n\r\n    .Career-containerFourTwo-Two-2-Line2 {\r\n        margin-top: -5px;\r\n        font-size: 20px;\r\n        font-weight: 800;\r\n        line-height: 1;\r\n    }\r\n\r\n    .Career-containerFourTwo-Two-2-Line3 {\r\n        margin-top: 5px;\r\n        font-size: 15px;\r\n        font-weight: 400;\r\n        line-height: 1.5;\r\n    }\r\n}\r\n\r\n\r\n/* 5 */\r\n.Career-containerFive {\r\n    margin-bottom: var(--margin-bottom-web);\r\n    font-size: 36px;\r\n    font-weight: lighter;\r\n    line-height: 60px;\r\n    text-align: center;\r\n}\r\n\r\n.Career-containerFive-Line1 {\r\n    margin: 0px;\r\n}\r\n\r\n.Career-containerFive-Line2 {\r\n    font-weight: 900;\r\n    margin: 0px;\r\n}\r\n\r\n.Career-containerFive-Line2 span {\r\n    display: inline-block;\r\n    vertical-align: top;\r\n\r\n}\r\n\r\n.Career-containerFive-Line2 span img {\r\n    width: 100%;\r\n    height: auto;\r\n    vertical-align: middle;\r\n}\r\n\r\n/* media5 */\r\n@media (max-width: 1280px) {\r\n    .Career-containerFive {\r\n        margin: 10% 5%;\r\n    }\r\n}\r\n\r\n@media (max-width: 500px) {\r\n\r\n    .Career-containerFive {\r\n        margin-top: -80px;\r\n        font-size: 25px;\r\n        line-height: 1.5;\r\n        margin-bottom: 80px;\r\n    }\r\n\r\n    .Career-containerFive-Line1 {\r\n        margin: 10px;\r\n    }\r\n\r\n\r\n    .Career-containerFive-Line2 span img {\r\n        width: 90%;\r\n        height: auto;\r\n        vertical-align: top;\r\n    }\r\n\r\n    #Job-Opening {\r\n        display: none;\r\n    }\r\n}\r\n\r\n/* 6 */\r\n\r\n.Career-containerSix {\r\n    margin: 0% 10% 5rem 10%;\r\n    /* margin-bottom: var(--margin-bottom-web); */\r\n}\r\n\r\n.Career-containerSix-one p {\r\n    margin-top: 50px;\r\n    font-size: 28px;\r\n    margin: 0px;\r\n    text-align: center;\r\n}\r\n\r\n.Career-containerSix-one>:nth-child(1) {\r\n    font-weight: lighter;\r\n}\r\n\r\n.Career-containerSix-one>:nth-child(2) {\r\n    font-weight: bolder;\r\n}\r\n\r\n.Career-containerSix-Two {\r\n    margin-top: 30px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
